import { ArrowRight, Filter, Search, Calendar, List, Grid, } from "react-feather";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { DatePicker, DateRangePicker } from "rsuite";
import { Link } from "react-router-dom";
import styles from "../incomeList.module.css";
import dayjs from "dayjs";

const ListFilters = ({ setPage, setFilterData, setFilterOpen, filterOpen, filterData, selectProperty, propertyList, apartmentList, handleView, setCurrentFilterValue, incomeCategories }) => {

  return (<div className={`${styles.SearchFilterSec}`}>
    <div className={`${styles.SearchCon}`}>
      <div className={`${styles.SearchConSec}`}>
        <Search />
        <input
          type="text"
          placeholder="Search"
          onChange={(e) => {
            setFilterData((prev) => {
              return { ...prev, searchKey: e.target.value };
            });
            setPage(0);

            setCurrentFilterValue("search");
          }}
        />
      </div>
      <div className={`${styles.ListGridBUCard}`}>
        <div className={`${styles.ListGridBUSec}`}>
          <div className={`${styles.ListGridBU} ${styles.Active}`}>
            <List /> <span>List</span>
          </div>
          <div className={`${styles.ListGridBU}`} onClick={() => handleView("grid")}>
            <Grid /> <span>Grid</span>
          </div>
        </div>
      </div>
    </div>

    <div className={`${styles.FilterSec}`}>
      <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
        <p className={`${styles.FilterTitle}`}>
          Filters
          <span onClick={(e) => setFilterOpen(false)}>
            <ArrowRight />
          </span>
        </p>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width220} CusSelectFilter Filter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Property</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Property"
              value={filterData?.property}
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, property: e.target.value };
                });
                selectProperty(e.target.value);
                setCurrentFilterValue("property");
              }}
            >
              {propertyList?.map((i) => {
                return (<MenuItem key={i.value} value={i.value}>{i.label}</MenuItem>);
              })}
            </Select>
          </FormControl>
        </div>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Apartment</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Apartment"
              value={filterData?.apartment}
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, apartment: e.target.value };
                });
                setCurrentFilterValue("apartment");
              }}
            >
              {apartmentList.length === 0 && (<MenuItem disabled value={""}>Select Property First</MenuItem>)}
              {apartmentList?.map((i) => {
                return (<MenuItem key={i.value} value={i.value}>{i.label}</MenuItem>);
              })}
            </Select>
          </FormControl>
        </div>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Category</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Apartment"
              value={filterData?.category}
              onChange={(e) => {
                setFilterData((prev) => {
                  return {
                    ...prev,
                    category: e.target.value,
                  };
                });
                setCurrentFilterValue("category");
              }}
            >
              {incomeCategories && incomeCategories?.map((i) => {
                return (<MenuItem key={i.id} value={i.id}>{i.title}</MenuItem>);
              })}
            </Select>
          </FormControl>
        </div>
        {/* <div
            className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}
          >
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Status</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Status"
                onChange={(e) => {
                  setFilterData((prev) => {
                    return { ...prev, view: e.target.value };
                  });
                }}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="archived">Archived</MenuItem>
              </Select>
            </FormControl>
          </div> */}
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Payment Status</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Payment Status"
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, payment_status: e.target.value };
                });
                setCurrentFilterValue("payment_status");
              }}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value={1}>Completed</MenuItem>
              <MenuItem value={0}>Pending</MenuItem>
              <MenuItem value={2}>Failed</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className={`${styles.FilterCard}`}>
          <div className={`${styles.DashFilterSec} DashFilterSec Filter`}>
            <DateRangePicker
              format={"MM/dd/yy"}
              placeholder={"Filter by date"}
              placement={"bottomEnd"}
              caretAs={Calendar}
              showOneCalendar
              onChange={(date) => {
                setFilterData((prev) => {
                  return { ...prev, last_payment_date: date };
                });
                setCurrentFilterValue("last_payment_date");
              }}
            />
          </div>
        </div>

        <div className={`${styles.FilterCard}`}>
          <div className={`${styles.DashFilterSec} DashFilterSec Filter`}>
            <DatePicker
              oneTap
              format="MMM yyyy"
              placeholder={"Monthly Rentroll"}
              placement={"bottomEnd"}
              disabledDate={(date) => date > new Date()}
              caretAs={Calendar}
              onChange={(date) => {
                if (date) {
                  setFilterData((prev) => {
                    return { ...prev, rent_month_text: dayjs(date).format('MMM YYYY'), rent_month: dayjs(date).format('YYYY-MM'), category: 1 };
                  });
                } else {
                  setFilterData((prev) => {
                    return { ...prev, rent_month_text: '', rent_month: '', category: '' };
                  });

                }
                setCurrentFilterValue("monthly_rentroll");
              }}
            />
          </div>
        </div>
      </div>
      <div className={`${styles.ListGridBUCard}`}>
        <div className={`${styles.ListGridBUSec}`}>
          <div className={`${styles.ListGridBU} ${styles.Active}`}>
            <List /> <span>List</span>
          </div>
          <div className={`${styles.ListGridBU}`} onClick={() => handleView("grid")}>
            <Grid /> <span>Grid</span>
          </div>
        </div>
      </div>
      <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
        <Filter />
      </Link>
    </div>
  </div>);
};

export default ListFilters;